export const routerCliente=[
    {
        name:'Cliente',
        path:'/cliente',
        component:()=> import('./pages/cliente')
    }
]